import React from 'react';
import { BenefitsSectionProps } from './Types';

const BenefitsSection = ({
  backgroundImage,
  gradientOverlay = true,
  children,
}: BenefitsSectionProps) => {
  return (
    <section
      className="relative w-full bg-cover bg-center flex items-center justify-center mb-15"
      style={{
        backgroundImage: backgroundImage
          ? gradientOverlay
            ? `linear-gradient(0deg,rgba(0, 0, 36, 0.9) 0%, rgba(54, 54, 117, 0.5) 100%), url(${backgroundImage})`
            : `url(${backgroundImage})`
          : undefined,
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="w-full max-w-6xl text-white">{children}</div>
    </section>
  );
};

export default BenefitsSection;
